export const POST_ACTION = 'app/store/POST_ACTION';
export const DELETE_ACTION = 'app/store/DELETE_ACTION';
export const GET_ACTIONS = 'app/store/GET_ACTIONS';
export const GET_ACTIONS_SUCCESS = 'app/store/GET_ACTIONS_SUCCESS';
